//export const loadFileFieldsToHide=['optionName','whoSigns','dropZone','withTemplate','collapse','saveOption','optMessage','locate','combinePDF','ordered','sendConfirmation','sendAll','copyToCheck','multipleWorkflow','remind','combinedFileName'];
export const loadFileFieldsToHide=[];

